import {
  CertificationButton,
  type Props as CertificationButtonProps,
} from './certification-button'
import {
  type PhoneVerificationResult,
  useGetPhoneNumber,
} from '../api/get-phone-number'

type Props = Omit<CertificationButtonProps, 'onSuccess'> & {
  onSuccess?: ({ certNum, phoneNumber }: PhoneVerificationResult) => void
}

export const PhoneVerificationButton = ({
  onSuccess,
  disabled,
  ...restProps
}: Props) => {
  const { getPhoneNumber } = useGetPhoneNumber({
    onSuccess: ({ certNum, phoneNumber }) => {
      onSuccess?.({ certNum, phoneNumber })
    },
  })

  const handleCertificationSuccess = (certNum: string) => {
    getPhoneNumber(certNum)
  }

  return (
    <CertificationButton
      onSuccess={handleCertificationSuccess}
      disabled={disabled}
      {...(!disabled && {
        style: {
          background:
            'linear-gradient(90deg, rgba(78, 144, 249, 0.00) 0%, #4E90F9 100%), var(--Purple-purple-500, #895FFC)',
        },
      })}
      {...restProps}
    />
  )
}
